module.exports = __webpack_public_path__ + "static/media/search-icon.e178ddf0.svg";